import { Link } from "react-router-dom";
import { CaretRight } from "@phosphor-icons/react";

// items: [{ name, path }]
export default function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-xs tracking-wider text-neutral-500 mb-6" data-testid="breadcrumbs">
      {items.map((it, i) => (
        <span key={it.path} className="flex items-center gap-2">
          {i > 0 && <CaretRight size={12} />}
          {i === items.length - 1 ? (
            <span className="text-neutral-700 truncate max-w-[280px]">{it.name}</span>
          ) : (
            <Link to={it.path} className="hover:text-[#001588]">{it.name}</Link>
          )}
        </span>
      ))}
    </nav>
  );
}
